export default "__VITE_ASSET__38d437d0__"